// @flow
import React, { type Node } from 'react';
import { compose } from 'recompose';
import SendbirdProvider from '@sendbird/uikit-react/SendbirdProvider';

import useChatLogin from 'common/modules/chat/hooks/useChatLogin';
import withReducers from 'common/modules/redux/withReducers';
import { withErrorBoundary } from 'common/components/core/errors';
import ChatReducers from 'common/modules/chat/redux/reducers/chat';
import ChatApp from 'common/modules/chat/container/ChatApp';
import { neoUIColors } from 'common/enums/ColorEnum';

import '@sendbird/uikit-react/dist/index.css';
import './overrideSendBirdTheme.css';

const colorSet = {
    '--sendbird-light-primary-300': neoUIColors.blue100.code,
    '--sendbird-light-primary-400': neoUIColors.blue200.code,
    '--sendbird-light-ondark-01': neoUIColors.grey600.code,
    '--sendbird-light-background-50': neoUIColors.grey100.code,
    '--sendbird-light-background-100': neoUIColors.white.code
};

const reducers = {
    chat: ChatReducers
};

const ChatContainer = (): Node => {
    const { data, isLoading } = useChatLogin();
    const { userToken, userId, appId } = data || {};

    return !isLoading && data ? (
        <SendbirdProvider
            appId={appId}
            userId={userId}
            accessToken={userToken}
            colorSet={colorSet}
        >
            <ChatApp userId={userId} userToken={userToken} />
        </SendbirdProvider>
    ) : null;
};

export default compose(
    withErrorBoundary({
        minimal: true,
        defaultProps: {
            errorBoundaryTitleKey: 'genericError',
            errorBoundarySubtitleKey: 'errorMessages.chatError'
        }
    }),
    withReducers(reducers)
)(ChatContainer);
